import { isDefined } from "@clipboard-health/util-ts";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time. See https://www.notion.so/BP-Date-Time-2ef8643321f48032ad80e8a5b30aa278 for more information
import { format } from "date-fns";
// eslint-disable-next-line no-restricted-imports -- legacy, use @clipboard-health/date-time
import { formatInTimeZone } from "date-fns-tz";

/**
 * Formats a date into a string in the format "9:30 am"
 */
export function formatTime(date: Date, timezone?: string): string {
  if (isDefined(timezone)) {
    return formatInTimeZone(date, timezone, "h:mm a");
  }

  return format(date, "h:mm a", {}).toLowerCase();
}
